import type {
  ApolloCache,
  OperationVariables,
  QueryOptions,
} from '@apollo/client';

export const updateQuery = <
  TData extends object,
  TVariables extends OperationVariables,
>(
  cache: ApolloCache<any>,
  options: QueryOptions<TVariables, TData>,
  updater: (data: TData | null) => TData | null
) => {
  const data = cache.readQuery<TData, TVariables>(options);
  const updatedData = updater(data as TData | null);
  if (!updatedData) return;

  cache.writeQuery<any, TVariables>({
    ...options,
    data: updatedData,
  });
};
